// extracted by mini-css-extract-plugin
export var center_caracteristicas = "ProductDetail-module--center_caracteristicas--57f54";
export var container__destacado = "ProductDetail-module--container__destacado--90bb9";
export var container_center_caracteristicas = "ProductDetail-module--container_center_caracteristicas--26935";
export var container_details = "ProductDetail-module--container_details--8c4ff";
export var container_recipes = "ProductDetail-module--container_recipes--9995a";
export var container_recommendations = "ProductDetail-module--container_recommendations--7f5b9";
export var contenRecetasRelacionadas = "ProductDetail-module--contenRecetasRelacionadas--8f82f";
export var img__container = "ProductDetail-module--img__container--6efb1";
export var title = "ProductDetail-module--title--e6dd6";
export var titleContent = "ProductDetail-module--titleContent--0b413";